export default __webpack_public_path__ + "static/media/n-back-acustico-step3.f4466f4e.svg";